import { FormBase } from "core/components";

export default class FacilityInventoryCountModalEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: "facilityId",
                    label: "FACILITY_INVENTORY.EDIT.FACILITY_LABEL",
                    placeholder: "FACILITY_INVENTORY.EDIT.FACILITY_PLACEHOLDER",
                    rules: "string",
                },
                {
                    name: "countDate",
                    label: "FACILITY_INVENTORY.EDIT.COUNT_DATE_LABEL",
                    placeholder: "FACILITY_INVENTORY.EDIT.COUNT_DATE_PLACEHOLDER",
                    rules: "required",
                },
                {
                    name: "authorId",
                    label: "FACILITY_INVENTORY.EDIT.AUTHOR_LABEL",
                    placeholder: "FACILITY_INVENTORY.EDIT.AUTHOR_PLACEHOLDER",
                    rules: "string"
                }
            ],
        };
    }
}